import { show, hide } from 'redux-modal'
import { reset } from 'redux-form'
import { rest } from 'services'
import { SUCCESSFUL_SUBMIT_MODAL } from 'components/SuccessfulSubmitModal/constants'
import { CONTACT_US_FORM, FLEET_CONTACT_US_FORM, description, confirmButtonText } from './constants'
import { googleAnalyticEmailAddressFill } from 'actions/googleAnalytic'

export const submitCommentAction = values => dispatch =>
  rest.api.contactUs(values)
    .then(() => dispatch(reset(CONTACT_US_FORM)))
    .then(() => dispatch(googleAnalyticEmailAddressFill({
      isFormSubmission: true,
      emailCaptured: values.email,
      emailSubmissionLocation: window.location.href,
      firstName: values.name
    })))
    .then(() => dispatch(show(SUCCESSFUL_SUBMIT_MODAL, {
      description,
      confirmButtonText,
      onConfirm: () => dispatch(hide(SUCCESSFUL_SUBMIT_MODAL))
    })))
    .catch(err => console.error(err))

export const submitFormAction = values => dispatch =>
  rest.api.fleetServicesContactUs(values)
    .then(() => dispatch(reset(FLEET_CONTACT_US_FORM)))
    .then(() => dispatch(googleAnalyticEmailAddressFill({
      isFormSubmission: true,
      emailCaptured: values.email,
      emailSubmissionLocation: window.location.href,
      firstName: values.name
    })))
    .then(() => dispatch(show(SUCCESSFUL_SUBMIT_MODAL, {
      description,
      confirmButtonText,
      onConfirm: () => dispatch(hide(SUCCESSFUL_SUBMIT_MODAL))
    })))
    .catch(err => console.error(err))
